// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1f80a7f8","94":"9aadf740","364":"dadc2ce0","488":"66ac2e08","616":"4d6b2fb5","787":"0e61a5cb","803":"e736d3dd","907":"2255937e"}[chunkId] + ".chunk.js";
};